import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OrnamentDivider } from '../ui/OrnamentDivider';

export function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-mafia-black border-t border-mafia-border mt-auto">
      <OrnamentDivider className="px-8 pt-8 pb-6" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-4 mb-3">
              <img
                src="/logo.jpg"
                alt="Queensland Mafia Club"
                className="h-16 w-16 rounded-full drop-shadow-[0_0_12px_rgba(201,162,55,0.25)]"
              />
              <div>
                <h3 className="font-display text-lg font-bold text-mafia-gold leading-tight">
                  Queensland
                </h3>
                <h3 className="font-display text-lg font-bold text-mafia-gold leading-tight">
                  Mafia Club
                </h3>
              </div>
            </div>
            <p className="text-mafia-paper-dim text-sm leading-relaxed">{t('footer.description')}</p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-mono text-xs text-mafia-gold tracking-[0.2em] uppercase mb-4">
              {t('footer.links')}
            </h4>
            <ul className="space-y-2">
              {[
                { to: '/about', label: t('nav.about') },
                { to: '/rules', label: t('nav.rules') },
                { to: '/schedule', label: t('nav.schedule') },
                { to: '/scoreboard', label: t('nav.scoreboard') },
                { to: '/news', label: t('nav.news') },
                { to: '/links', label: t('nav.links') },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-sm text-mafia-muted hover:text-mafia-gold transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Venue */}
          <div>
            <h4 className="font-mono text-xs text-mafia-gold tracking-[0.2em] uppercase mb-4">
              {t('footer.contact')}
            </h4>
            <p className="text-mafia-paper-dim text-sm leading-relaxed">{t('footer.venue')}</p>
            <p className="text-mafia-paper-dim text-sm mt-2">{t('footer.schedule')}</p>
            <a
              href="https://t.me/queenslandmafia"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-mafia-muted hover:text-mafia-gold transition-colors mt-3"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
              </svg>
              Telegram
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-mafia-border mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-mafia-muted text-xs font-mono tracking-wide">
            © 2026 Клуб Мафии Квинсленда. {t('footer.rights')}
          </span>
          <div className="flex items-center gap-1 text-mafia-muted/40 text-xs">
            <span>◆</span>
          </div>
          <div className="flex gap-6">
            <Link
              to="/privacy"
              className="text-mafia-muted hover:text-mafia-gold text-xs font-mono tracking-wide uppercase transition-colors"
            >
              {t('footer.privacy')}
            </Link>
            <Link
              to="/terms"
              className="text-mafia-muted hover:text-mafia-gold text-xs font-mono tracking-wide uppercase transition-colors"
            >
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
